import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BasketLineItemPrice',
  props: {
    unitPrice: null,
    discountedUnitPrice: null,
    vatText: null,
    showVatText: { type: Boolean },
    unitPriceText: null,
    unitOfferPriceText: null
  },
  setup(__props: any) {

const props = __props as {
    unitPrice: string,
    discountedUnitPrice?: string | null,
    vatText?: string | null,
    showVatText: boolean,
    unitPriceText: string,
    unitOfferPriceText: string
}




const hasDiscountedUnitPrice = computed(() => !!props.discountedUnitPrice);

return { __sfc: true,props, hasDiscountedUnitPrice }
}

})